<template>
  <v-layout>
    <v-spacer/>
    <v-btn id="alert-delete" aria-label="alert-delete" color="error" class="mx-0" @click="deleteAlert">
      <v-icon>delete</v-icon>
      {{$t('admin.alerts.new.delete_alert')}}
    </v-btn>
  </v-layout>
</template>
<script>
  import { DELETE_ALERT } from '../../../store/action-types'

  export default {
    name: 'alert-delete-button',
    props: {
      alertId: {
        type: Number
      }
    },
    methods: {
      deleteAlert () {
        let payload = {
          alertId: this.alertId,
          toBeDeleted: true
        }
        this.$store.dispatch(DELETE_ALERT, payload)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/settings/alert/AlertDeleteButton.vue